import { render, staticRenderFns } from "./yhbWithdrawFace.vue?vue&type=template&id=821899c6"
import script from "./yhbWithdrawFace.vue?vue&type=script&lang=js"
export * from "./yhbWithdrawFace.vue?vue&type=script&lang=js"
import style0 from "./yhbWithdrawFace.vue?vue&type=style&index=0&id=821899c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports